// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oCor","toggleWrap":"styles_toggleWrap__3J9Id","content":"styles_content__2oJhr","selectAreaCode":"styles_selectAreaCode__3CqXH"};